<template>
    <div id="fptai-tts">
        <v-layout row wrap>
            <v-flex lg6 md12 pr-3>
                <v-form v-model="formValid" @submit="submit">
                    <v-text-field
                        :label="$t('phone') | capitalize"
                        :rules="[formRules.ruleRequired, formRules.rulePhone]"
                        v-model="model.phone"
                    ></v-text-field>
                    <v-select
                        :label="$t('typeOfLoan') | capitalize"
                        :items="dlTypeList"
                        v-model="model.dltype"
                    ></v-select>
                    <v-select
                        :label="$t('dataSource') | capitalize"
                        :items="dataSourceList"
                        v-model="model.dataSource"
                    ></v-select>
                    <v-layout>
                        <DatePicker
                            v-model="date"
                            clearable
                            :required="false"
                            class="mr-3"
                            :label="$t('date') | capitalize"
                        ></DatePicker>
                        <TimePicker
                            v-model="time"
                            clearable
                            :required="false"
                            :label="$t('time') | capitalize"
                        ></TimePicker>
                    </v-layout>
                    <v-layout justify-end>
                        <v-btn color="primary" type="submit">
                            {{$t('check') | capitalize}}
                        </v-btn>
                    </v-layout>
                </v-form>
                <div class="title mb-3">{{$t('result') | capitalize}}</div>
                <table v-if="result">
                    <tr>
                        <td>{{$t('phone') | capitalize}}</td>
                        <td>{{result.phone}}</td>
                    </tr>
                    <tr>
                        <td>Sendo</td>
                        <td>{{result.sendo_score}}</td>
                    </tr>
                    <tr>
                        <td>FPT</td>
                        <td>{{result.fpt_score}}</td>
                    </tr>
                    <tr>
                        <td>FRT</td>
                        <td>{{result.frt_score}}</td>
                    </tr>
                    <tr>
                        <td>{{$t('score') | capitalize}}</td>
                        <td>{{result.score}}</td>
                    </tr>
                </table>
            </v-flex>
            <v-flex lg6 md12 style="text-align: left">
                <h2 class="py-2">API</h2>
                <v-select
                    label="API Key"
                    v-model="apiKey"
                    :items="listAPIKey"
                    class="mt-3"
                ></v-select>
                <v-layout row reverse wrap align-center>
                    <v-btn
                        @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                        title="copy key to clipboard"
                        class="ma-0"
                        depressed
                        color="info"
                    >
                        <v-icon>file_copy</v-icon>
                        Copy
                    </v-btn>
                    <v-radio-group v-model="apiType" row>
                        <v-radio label="cUrl " value="curl"></v-radio>
                        <v-radio label="Python" value="python"></v-radio>
                        <v-radio label="Php" value="php"></v-radio>
                    </v-radio-group>
                </v-layout>
                <code style="width: 100%">{{code[apiType]}}</code>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import ApiDemo from '@/views/APIs/demo/ApiDemo'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import axios from 'axios'
import DatePicker from '@/modules/fptai/components/DatePicker'
import TimePicker from '@/modules/fptai/components/TimePicker'
/* eslint-disable */
import { inject } from '@/utils/VariableInjection'
import idrPython from 'raw-loader!../code/csPython.txt'
import idrCUrl from 'raw-loader!../code/csCUrl.txt'
import idrPHP from 'raw-loader!../code/csPHP.txt'
/* eslint-enable */

export default {
    name: 'CreditScoreDemo',
    extends: ApiDemo,
    mixins: [FormMixin],
    components: { DatePicker, TimePicker },
    data () {
        return {
            model: {
                phone: '',
                dltype: 1,
                dataSource: 0,
                decision_time: 0
            },
            date: '',
            time: '',
            dataSourceList: [
                { text: this.$filters.capitalize(this.$t('all')), value: 0 },
                { text: 'FPT FB social network', value: 1 },
                { text: 'Sendo', value: 2 },
                { text: 'FRT', value: 3 }
            ],
            dlTypeList: [
                { text: 'CD', value: 1 },
                { text: 'Cash Loan', value: 2 }
            ],
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_CREDIT_SCORE,
            result: null
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: this.demoUrl,
                apiKey: this.apiKey,
                path: this.imageName
            }
            return {
                python: inject(idrPython, variableMap),
                curl: inject(idrCUrl, variableMap),
                php: inject(idrPHP, variableMap)
            }
        }
    },
    methods: {
        validateDateTime () {
            if ((this.date && !this.time) || (!this.date && this.time)) {
                return false
            }
            if (this.date && this.time) {
                let time = this.date + 'T' + this.time + ':00' + this.$utils.getClientGMT()
                return this.$moment(time).unix()
            }
            return this.$moment().unix()
        },
        submitValidForm () {
            let dateTime = this.validateDateTime()
            if (dateTime === false) {
                this.$appService.toastError(this.$t('fillDateAndTime'))
            } else {
                this.model.decision_time = dateTime
            }
            this.$appService.showLoading()
            this.result = null
            axios.get(
                process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_CREDIT_SCORE,
                {
                    headers: {
                        'api-key': this.apiKey,
                        'Content-Type': 'multipart/form-data'
                    },
                    params: this.model
                }
            ).then(
                result => {
                    this.result = result.data
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('check'),
                    item: this.$t('phone')
                }))
            ).finally(this.$appService.hideLoading)
        },
        buildDemoUrl () {
            let decisionTime = this.validateDateTime()
            if (decisionTime === false) {
                decisionTime = this.$moment().unix()
            }
            let url = process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_CREDIT_SCORE + '?'
            for (let i in this.model) {
                if (i !== 'decision_time') {
                    url += i + '=' + this.model[i] + '&'
                } else {
                    url += i + '=' + decisionTime + '&'
                }
            }
            this.demoUrl = url.substring(0, url.length - 1)
        }
    },
    watch: {
        date () {
            if (!this.time) {
                this.time = '00:00'
            }
            this.buildDemoUrl()
        },
        time () {
            if (!this.date) {
                this.date = this.$moment().format('YYYY-MM-DD')
            }
            this.buildDemoUrl()
        },
        model: {
            deep: true,
            handler: function () {
                this.buildDemoUrl()
            }
        }
    }
}
</script>

<style scoped>
    table tr td {
        padding: 5px 10px 5px 0;
    }
</style>
